import { Button, Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router';
import { OrderReviewContext } from './OrderReviewContext';
import DisplayObject from './DisplayObject';
import UncontrolledImage from '../ReactHookForm/Inputs/UncontrolledImage';

import { ResyncHoverOrder, DeleteHoverSketch, UploadHoverSketch } from '../../services';
import HoverSketchUploadDialog from './ActionBar/Attachments/QAPhotoUploadDialogMenuItem/HoverSketchUploadDialog';
import RetrieveHoverPhotosDialog from './ActionBar/Attachments/QAPhotoUploadDialogMenuItem/RetrieveHoverPhotosDialog';

const propTypes = {
    classes: PropTypes.object.isRequired,
};

function HoverSketch({ classes }) {
    const { state } = useContext(OrderReviewContext);
    const data = state.formHeaders[state.activeFormHeaderIndex]

    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [showUploadDialog, setShowUploadDialog] = useState(false);
    const [showRetrieveDialog, setShowRetrieveDialog] = useState(false);

    const images = data?.images

    const hoverImage = images?.filter(image => {
        return image.imageUri.includes("Sketch")
    })?.at(-1)

    const hoverImageUri = images?.filter(image => {
        return image.imageUri.includes("Sketch")
    })?.at(-1)?.imageUri

    const { orderLineId, isAdmin, isQA } = state;

    const hoverOrderFormHeaderId = data?.orderFormHeaderId;

    const resyncHover = async () => {
        try {
            setIsLoading(true);
            await ResyncHoverOrder(orderLineId);
            window.location.reload();
        }
        catch (error) {
            alert('Error getting hover sketch');
            setIsLoading(false);
        }
        setIsLoading(false);
    }

    const deleteHoverSketch = async () => {
        try {
            setIsDeleting(true);
            await DeleteHoverSketch(hoverImage?.formQaImageId, orderLineId);
            window.location.reload();
        }
        catch (error) {
            alert('Error getting hover sketch');
            setIsDeleting(false);
        }
        setIsDeleting(false);
    }

    return (
        <Grid item xs={12} className={classes.container}>
            <HoverSketchUploadDialog open={showUploadDialog} onClose={() => setShowUploadDialog(false)} orderFormHeaderId={hoverOrderFormHeaderId} />
            <RetrieveHoverPhotosDialog open={showRetrieveDialog} onClose={() => setShowRetrieveDialog(false)} />
            <div style={{ display: 'flex' }}>
                {(isAdmin || isQA) && (
                    <div style={{ display: 'flex', marginBottom: 15, marginRight: 15 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={resyncHover}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : 'Resync Hover Order'}
                        </Button>
                    </div>
                )}
                {isAdmin && (
                    <>
                        <div style={{ display: 'flex', marginBottom: 15, marginRight: 15 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setShowUploadDialog(true)}
                            >
                                Upload Hover Sketch
                            </Button>
                        </div>
                        <div style={{ display: 'flex', marginBottom: 15, marginRight: 15 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setShowRetrieveDialog(true)}
                            >
                                Retrieve Hover Photos
                            </Button>
                        </div>
                    </>
                )}
                {(isAdmin || isQA) && (
                    <div style={{ display: 'flex', marginBottom: 15 }}>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: '#F44336', color: 'white' }}
                            onClick={deleteHoverSketch}
                            disabled={isDeleting}
                        >
                            {isDeleting ? 'Loading...' : 'Delete Hover Sketch'}
                        </Button>
                    </div>
                )}
            </div>

            <Card className="border-left-green">
                <CardHeader
                    className={classes.cardHeader}
                    titleTypographyProps={{ className: classes.cardHeaderTitle }}
                    title="Hover Sketch"
                />
                <CardContent className={classes.cardContent}>
                    {hoverImageUri ? (
                        <div style={{ padding: "10px", height: "35%", width: "35%" }}>
                            <UncontrolledImage src={hoverImageUri} />
                        </div>
                    ) : (
                        <h2>No Sketch Available</h2>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
}

const styles = theme => ({
    container: {
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '100%',
        padding: 1,
        flex: 1,
    },
    cardContent: {
        padding: '0 !important',
    },
    cardHeader: {
        padding: '12px',
        backgroundColor: '#fafafa',
    },
    cardHeaderTitle: {
        fontSize: '1rem',
        fontWeight: '700',
        textAlign: 'left',
        color: 'var(--jmi-blue)',
    },
});

HoverSketch.propTypes = propTypes;
export default withStyles(styles)(withRouter(HoverSketch));
